import { Accordion, AccordionDetails, AccordionSummary, Box, Paper } from "@mui/material";
import { FC, useEffect, useMemo, useState } from "react";
import { ID } from "@/data/types/Basic";
import { WidgetProperties } from "@/data/types/Slot";
import { waitForElement } from "@/utils/waitForElementToLoad";
import { ContentRecommendation } from "../ContentRecommendation";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { AccordionDetailsSX, AccordionSummarySX, AccordionSX } from "./styles/faqContent";
import { ProgressIndicator } from "@/components/blocks/ProgressIndicator";
import { parseHTML } from '@/utils/parseHTML';

export const FAQContentRv: FC<{ id: ID; properties?: WidgetProperties }> = ({ id: _id, properties }) => {

    const emsName = useMemo(() => properties?.eMarketingSpotName ?? "", [properties]);

    const [faqObj, setFaqObj] = useState<Record<number, string[]>>({});
    const [faqIds, setFaqIds] = useState<number[]>([]);
    const [expanded, setExpanded] = useState(-1);
    const [showLoading, setShowLoading] = useState(true);

    useEffect(() => {
        waitForElement('#itnl_faq_content_accordion_container', 4000, `#faq_content_widget_rv_${emsName}`).then(() => {
            const faqs = document.querySelector(`#faq_content_widget_rv_${emsName} #itnl_faq_content_accordion_container`)?.children;
            if (faqs?.length) {
                const faqObj: Record<number, string[]> = chunkArrayToObject([...faqs]?.map(f => f.outerHTML));
                setFaqObj(faqObj);
                setFaqIds(Object.keys(faqObj).map(Number));
            }
        }).catch((error) => {
            console.debug(error.message);
            setShowLoading(false);
        });
    }, []);

    const handleChange = (panel: number) => (_event: any, isExpanded: boolean) => setExpanded(isExpanded ? panel : -1);

    const chunkArrayToObject = <T,>(arr: T[], size: number = 2): Record<number, T[]> =>
        arr.reduce((acc, _, i) => {
            if (i % size === 0) acc[(i / size) + 1] = arr.slice(i, i + size);
            return acc;
        }, {} as Record<number, T[]>);

    return (
        <Box className="faq-content-widget-rv" id={`faq_content_widget_rv_${emsName}`}>
            {faqIds.length ?
                faqIds.map(id =>
                    <Accordion
                        expanded={expanded === id}
                        key={id}
                        onChange={handleChange(id)}
                        sx={AccordionSX(faqIds?.at(-1) !== id)}
                    >
                        <AccordionSummary
                            expandIcon={expanded === id ? <RemoveIcon color="primary" /> : <AddIcon color="primary" />}
                            aria-controls={`panel${id}-content`}
                            id={`panel${id}-header`}
                            aria-label="Toon inhoud"
                            sx={AccordionSummarySX}
                        >
                            <Box>{parseHTML(faqObj[id][0])??''}</Box>
                        </AccordionSummary>
                        <AccordionDetails sx={AccordionDetailsSX}>
                            <Box>{parseHTML(faqObj[id][1]??'')}</Box>
                        </AccordionDetails>
                    </Accordion>
                )
                :
                <>
                    {showLoading ? <ProgressIndicator /> : null}
                    <Box display='none'><ContentRecommendation id={emsName} properties={{ emsName }} /></Box>
                </>
            }
        </Box>
    );
}